//import jwtDecode from "jwt-decode";

// const initialState = {
//     best_selling_products: [],
//     menu: [],
//     new_products: [],
//     sections: [],
//     special_offer_products: [],
//     sliders: []
// }
import {Text_lock} from "../../../views/web/textHome";

export const ui = (state = {}, action) => {
    switch (action.type) {
        case "UI": {
            return {
                category_parent: action.payload.category_parent,
                brands: action.payload.brands,
                best_selling_products: action.payload.best_selling_products,
                contact_us: action.payload.contact_us,
                menu: action.payload.menu,
                new_products: action.payload.new_products,
                sections: action.payload.sections,
                special_offer_products: action.payload.special_offer_products,
                sliders: action.payload.sliders,
                articles: action.payload.articles,
                story: action.payload.story,
                cc_tv: action.payload.cc_tv,
                burglar_alarm_premises: action.payload.burglar_alarm_premises,
                stabilizers: action.payload.stabilizers,
                door_jack: action.payload.door_jack,
                door_lock: action.payload.door_lock,
                notice: action.payload.notice,
            }
        }
        default: {
            return state
        }
    }
}
